import axios from "axios";

axios.defaults.baseURL = "https://aldahayan.net/api";
//axios.defaults.baseURL = "https://localhost:7022/api";

axios.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
